export const PageLoad = "Engagement Page Load";
export const PageLoadAction = "Click";
export const PageLoadNote = "";

export const LoanSelected = "Loan";
export const InvestmentSelected = "Investment";
export const SuperSelected = "Super";

export const tabCreatedAction = "Create New";
export const tabSelectedAction = "Select Existing";
export const DownloadExcelFile = "Download Excel File";
export const CompareAction = "Compare";
export const DownloadPDFFile = "Download PDF File";
export const DownloadWordFile = "Download Word File";
export const CompareCreatedAction = "Create New Instance";
export const SelectedInstance = "selectedInstance"; //Note : fact

export const DuplicateAction = "Duplicate";
export const RenameAction = "Rename";
export const DeleteAction = "Delete";

export const UpdateAction = "Update Graph";
export const AdvaceGraphAction = "Advance Action ";
export const SaveAction = "Save Graph"; // Type
export const SaveAsAction = "Save AsGraph"; // Type
